/** Locale-aware welcome tour route paths and helpers for onboarding navigation. */
import { getCurrentLocale } from '@/i18n/useT';

/** Locale → onboarding welcome tour path (EN + NL). */
export const ONBOARDING_WELCOME_PATHS = {
  en: '/app/welcome',
  nl: '/app/welkom',
};

/** Path for the active locale at navigation time (not reactive). */
export function getOnboardingWelcomePath() {
  const locale = getCurrentLocale();
  return ONBOARDING_WELCOME_PATHS[locale] ?? ONBOARDING_WELCOME_PATHS.nl;
}

/** True for either registered welcome path (bookmarks / wrong-locale links). */
export function isOnboardingWelcomePath(pathname) {
  return Object.values(ONBOARDING_WELCOME_PATHS).includes(pathname);
}

/** Set true when welcome paths are registered in `App.jsx`. */
export const IS_ONBOARDING_WELCOME_ROUTE_ENABLED = true;
